import styled, { keyframes } from "styled-components";
import { paletas } from "../../styles/theme";

const AnimaBGMais = keyframes`
 from {
  transform: scale(0) rotate(0deg);
 }
 0.5% {
  transform: scale(1) rotate(0deg);
 }
 to {
  transform: scale(1) rotate(360deg);  
 }
`;

const AnimaTela = keyframes`
 from {
  left: -100%;
  opacity: 0;
 }
 to {
  left: 0%;
  opacity: 1;
 }
`;

const animaErro = keyframes`
  from {
    margin-right: -10px;
  }
  25% {
    margin-right: -25px;
  }
  50% {
    margin-right: -5px;
  }
  75% {
    margin-right: -15px;
  }
  to {
    margin-right: 0px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-direction: column;
  height: 100vh;
  margin: 0 40px;
  text-transform: uppercase;

  a {
    color: ${paletas.White};
    margin: 3px 0;
  }

  form {
    width: 100%;
    max-width: 600px;
    margin: 0 10px;
    position: relative;
    transition: all 0.25s;
    animation: 0.3s ${AnimaTela} ease-in-out;

    div {
      display: flex;
      justify-content: center;
    }
  }

  input {
    width: 100%;
    margin: 10px 0;
    padding: 10px;
    border: none;
    border-radius: 0.25rem;
    transition: all 0.25rem;
  }

  span {
    color: ${paletas.RedLight};
  }

  .container-password {
    position: relative;
    transition: all 0.25rem;

    button {
      transition: all 0.25rem;
      position: absolute;
      right: 0;
      top: 0;
      border: none;
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 50px;
      padding: 5px 10px 3px;

      margin-top: 16px;
      margin-right: 10px;
    }
  }

  .container-captcha {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    align-content: center;
    margin-top: 10px;

    div {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      max-width: 200px;
      font-size: 14px;
      text-align: right;

      input {
        max-width: 50px;
      }

      input[type="checkbox"] {
        display: none;
        transition: all 0.25s;
      }
      input[type="checkbox"] + label span {
        display: inline-block;
        width: 19px;
        height: 19px;
        border-radius: 50%;
        margin: -2px 10px 0 0;
        vertical-align: middle;
        border: 1px solid ${paletas.DarkOrange};
        cursor: pointer;
        transition: all 0.25s;
      }
      input[type="checkbox"]:checked + label span {
        background: ${paletas.DarkOrange};
        border: 1px solid ${paletas.DarkOrange};
        transition: all 0.25s;
      }
      input[type="checkbox"]:disabled + label span {
        opacity: 0.5;
        transition: all 0.25s;
      }
    }
  }

  .input-submit {
    font-family: "Big Shoulders Stencil Text", Arial, Helvetica, sans-serif;
    background-color: ${paletas.DarkOrange};
    color: ${paletas.Grafite};
    font-weight: bold;
    font-size: 18px;
    border: 1px solid ${paletas.Grafite};
    border-radius: 0.25rem;
    padding: 10px 0;
    cursor: pointer;
    transition: all 0.25s;
    text-transform: uppercase;

    &:hover {
      color: ${paletas.DarkOrange};
      background: ${paletas.Grafite};
      border: 1px solid ${paletas.DarkOrange};
    }
  }
`;

export const BgMais = styled.div`
  position: absolute;
  width: 200px;
  height: 200px;
  left: -30px;
  top: -30px;
  transition: all 2s;
  clip-path: polygon(
    35% 0%,
    65% 0%,
    65% 35%,
    100% 35%,
    100% 60%,
    65% 60%,
    65% 100%,
    35% 100%,
    35% 60%,
    0% 60%,
    0% 35%,
    35% 35%
  );
  background: rgba(0, 0, 0, 0.2);
  z-index: -1;
  animation: 60s ${AnimaBGMais} infinite linear;

  @media (min-width: 400px) {
    top: -40px;
    width: 300px;
    height: 300px;
  }

  @media (min-width: 700px) {
    width: 400px;
    height: 400px;
  }
`;

export const Erro = styled.div`
  span {
    font-size: 14px;
    position: relative;
    width: 100%;
    display: block;
    transition: all 0.25s;
    animation: 0.5s ${animaErro} ease;
  }
`;
